const ga4 = {
    pages: [
        {
            type: 'product',
            eventName: 'view_item',
            selector: 'body.product-detail'
        },
        {
            type: 'checkout',
            eventName: 'begin_checkout',
            selector: 'body.checkout',
            itemSelector: '.checkout-item-cart',
            formSelector: '#checkout-form'
        },
        {
            type: 'cart',
            eventName: 'view_cart',
            selector: 'body.cart',
            itemSelector: '.item-cart'
        }
    ],
    eventList: [
        {
            type: 'product',
            eventName: 'add_to_cart',
            selector: 'a.btn-add-subscription'
        },
        {
            type: 'product-list',
            eventName: 'select_item',
            selector: 'body.shop a.view-product-link'
        }
    ],
    getClientId: () => {
        const match = document.cookie.match(/_ga=GA\d+\.\d+\.(\d+\.\d+)/)
        return match ? match[1] : null
    },
    init: () => {
        // Init dataLayer if not exists
        window.dataLayer = window.dataLayer || [];
        // Start tracking current page
        ga4.trackPage();
        // Track events
        ga4.trackEvents();
    },
    getCurrency: () => {
        return 'EUR'
    },
    getBrand: () => {
        return 'Siber'
    },
    trackPage: () => {
        const currentPage = ga4.pages.find(page => $(page.selector).length > 0);
        if(currentPage) {
            if(currentPage.type === 'product' && window.productData) {
                ga4.trackProductPageView(currentPage.eventName, window.productData);
            } else if (currentPage.type === 'checkout' || currentPage.type === 'cart') {
                ga4.trackCheckoutPageView(currentPage);
            }
        }
    },
    trackProductPageView: (eventName, productData) => {
        const data = {
            ecommerce: {
                currency: 'EUR',
                value: productData.price,
                items: [
                    {
                        ...productData,
                        item_brand: 'Siber',
                        quantity: 1
                    }
                ]
            }
        }
        ga4.sendEvent(eventName, data);
    },
    trackCheckoutPageView: (currentPage) => {
        const { eventName, itemSelector, formSelector } = currentPage;
        let totalCartValue = 0;
        const items = [];
        let discountCode = null;
        $(itemSelector).each((_, elem) => {
            let discountData = {};
            // console.log($(elem).data());
            if ($(elem).data('item_discount_code') && $(elem).data('item_discount_value')) {
                discountCode = $(elem).data('item_discount_code');
                discountData.coupon = discountCode;
                discountData.discount = $(elem).data('item_discount_value');
            }
            items.push({
                item_id: $(elem).data('item_id'),
                item_name: $(elem).data('item_name'),
                price: $(elem).data('item_price'),
                item_brand: ga4.getBrand(),
                item_category: $(elem).data('item_category'),
                quantity: parseInt($(elem).data('item_quantity')),
                ...discountData
            })

            totalCartValue += $(elem).data('item_price') * $(elem).data('item_quantity');
        })

        const ecommerceData = {
            currency: ga4.getCurrency(),
            value: totalCartValue,
            items: items
        }
        if(discountCode) {
            ecommerceData.coupon = discountCode;
        }
        ga4.sendEvent(eventName, {
            ecommerce: ecommerceData
        })

        if (!formSelector) return;

        // Add input with client_id into form before submit
        const clientId = ga4.getClientId();
        if(clientId) {
            const $input = $('<input/>', {
                type: 'hidden',
                name: 'ga_client_id',
                value: clientId
            });
            $(formSelector).append($input);
        }
    },
    trackEvents: () => {
        for(const eventItem of ga4.eventList) {
            // Add to cart event, handle it in frontend-shop-custom.send_product_to_cart
            // Other events...
            $(document).on('click', eventItem.selector, (e) => {
                let eventCallback = null
                if ($(e.target).is('a')) {
                    e.preventDefault()
                    eventCallback = () => {
                        setTimeout(() => {
                            window.location.href = e.target.href
                        }, 250)
                    }
                }

                const data = {
                    item_id: $(e.target).data('item_id'),
                    item_name: $(e.target).data('item_name'),
                    item_price: $(e.target).data('item_price'),
                    item_category: $(e.target).data('item_category'),
                    item_quantity: parseInt($(e.target).data('item_quantity'))
                }
                ga4.trackAddToCartEvent(eventItem.eventName, data, eventCallback);
            });
        }
    },
    trackRemoveFromCart: (eventName, data, eventCallback = null) => {       
        // TODO: send ga_client_id 
        const productData = {
            ecommerce: {
                currency: ga4.getCurrency(),
                value: data.item_price,
                items: [
                    {
                        item_id: data.item_id,
                        item_name: data.item_name,
                        price: data.item_price,
                        item_brand: ga4.getBrand(),
                        item_category: data.item_category,
                        quantity: parseInt(data.item_quantity)
                    }
                ]
            }
        }
        ga4.sendEvent(eventName, productData, eventCallback);
    },
    trackAddToCartEvent: (eventName, data, eventCallback = null) => {       
        // TODO: send ga_client_id 
        const productData = {
            ecommerce: {
                currency: ga4.getCurrency(),
                value: data.item_price,
                items: [
                    {
                        item_id: data.item_id,
                        item_name: data.item_name,
                        price: data.item_price,
                        item_brand: ga4.getBrand(),
                        item_category: data.item_category,
                        quantity: parseInt(data.item_quantity)
                    }
                ]
            }
        }

        ga4.sendEvent(eventName, productData, eventCallback);
    },
    sendEvent: (eventName, data, eventCallback = null) => {
        const datalayerData = {
            event: eventName,
            ...data,
            eventCallback,
            eventTimeout: 2000
        }
        dataLayer.push(datalayerData);
        // DEV: DEBUG: REMOVE TO PROD
        // console.log(datalayerData, 'Datalayer sent', data);
    }
}


$(() => {
    window.ga4 = ga4;
    window.ga4.init();
});